export const ArrowRightIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='10' height='12' viewBox='0 0 10 12' fill='none'>
    <path d='M1.78296 1L7.72656 5.97635L1.72656 11' stroke='white' strokeWidth='2' strokeLinecap='round' />
  </svg>
)
